import { UpsellProductsDto } from '@maia/shared';

type GetDefaultFormValues = (
  data: Array<UpsellProductsDto>,
) => Record<string, string>;
export const getDefaultFormValues: GetDefaultFormValues = (data) => {
  return data.reduce(
    (acc, product) => {
      acc[`${product.guid}|${product.riskPool}`] = '';
      return acc;
    },
    {} as Record<string, string>,
  );
};
